var map = {
	"./banner_barons.png": 8649,
	"./banner_chiefs.png": 2665,
	"./banner_counts.png": 6436,
	"./banner_crown.png": 5796,
	"./banner_grandees.png": 5356,
	"./banner_patricians.png": 3212,
	"./bldgNameBg.png": 1870,
	"./button_join_rebellion.png": 9960,
	"./flag_barons.png": 2937,
	"./flag_chiefs.png": 8236,
	"./flag_counts.png": 9932,
	"./flag_grandees.png": 5028,
	"./flag_patricians.png": 5739,
	"./icon_aqueduct.png": 8944,
	"./icon_cathedral.png": 8727,
	"./icon_deer park.png": 2698,
	"./icon_fortress.png": 8346,
	"./icon_grand bazaar.png": 7603,
	"./icon_library.png": 6273,
	"./icon_monument.png": 1778,
	"./icon_observatory.png": 8670,
	"./icon_prison.png": 2314,
	"./icon_stadium.png": 9539,
	"./icon_theatre.png": 8182,
	"./icon_thieves guild.png": 55,
	"./pledgeBg.png": 578,
	"./stat_treasury.png": 9304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;